<div
  id="html2Pdf"
  class="right-panel position-relative scrollable-element"
  #pdfContent
>
  <div>
    <div class="actionBar" *ngIf="!downloadingPdf">
      <ng-select
        class="me-2 w-8"
        #deploymentFilter
        title="Select Deployment"
        [clearable]="false"
        [(ngModel)]="depName"
        id="depFilter"
        name="DeploymentFilter"
        (ngModelChange)="deploymentFilterApplied()"
      >
        <ng-option *ngFor="let dep of deployments" [value]="dep">
          {{ dep }}
        </ng-option>
      </ng-select>
      <ng-select
        #metricFilter
        title="Select Metric"
        name="metricFilter"
        [(ngModel)]="selectedMetric"
        id=""
        [clearable]="false"
        class="ngselect me-2"
        (ngModelChange)="optionClicked()"
      >
        <ng-option selected value="all">Overview</ng-option>
        <ng-option value="SessionGraph" *ngIf="isVdi">User Sessions</ng-option>
        <ng-option value="JobSummary" *ngIf="!isVdi"
          >Job Status Summary</ng-option
        >
        <ng-option value="JobCompleted" *ngIf="!isVdi">Job Completed</ng-option>
        <ng-option value="JobDataCount" *ngIf="!isVdi"
          >Job Submit Count</ng-option
        >
        <ng-option value="PrimeNonPrimeJobSubmission" *ngIf="!isVdi">
          Job Submit Count By Working Hours
        </ng-option>
        <ng-option value="JobByApplication" *ngIf="!isVdi">
          Job By Application
        </ng-option>
        <ng-option value="JobByNodes" *ngIf="!isVdi">Job By Nodes</ng-option>
        <ng-option value="JobByNodeGroup" *ngIf="!isVdi"
          >Job By Node Group</ng-option
        >
        <ng-option value="RunningQueuedJobsPerNodeGroup" *ngIf="!isVdi">
          Job By Node Group By Interval
        </ng-option>
        <ng-option value="JobWaitTime" *ngIf="!isVdi">Job Wait Time</ng-option>
        <ng-option value="JobByUser" *ngIf="!isVdi">Job By Users</ng-option>
        <ng-option value="JobByGroup" *ngIf="!isVdi">Job By Groups</ng-option>
        <ng-option value="JobByTags" *ngIf="!isVdi">Job By Tags</ng-option>
        <ng-option value="JobByTagsPerDay" *ngIf="!isVdi"
          >Job By Tags By Interval</ng-option
        >
        <ng-option value="StorageUsage" *ngIf="!isVdi">Storage Usage</ng-option>
        <ng-option value="CoresByApplication" *ngIf="!isVdi">
          Cores By Application
        </ng-option>
        <ng-option value="CoreHoursByUsers" *ngIf="!isVdi">
          Core Hours By Users
        </ng-option>
        <ng-option value="CoreHoursByGroups" *ngIf="!isVdi"
          >Core Hours By Groups</ng-option
        >
        <ng-option value="CoreUsage" *ngIf="!isVdi">Avg Core Usage</ng-option>
        <ng-option value="NodeAvailability" *ngIf="!isVdi">
          Node Availability
        </ng-option>
        <ng-option value="NodeUtilization"> Avg Node Utilization </ng-option>
        <ng-option value="SingleNodeUtilization">
          Single Node Utilization
        </ng-option>
        <ng-option value="ActiveSessions" *ngIf="isVdi"
          >Active Sessions</ng-option
        >
        <ng-option value="AllUserSessions" *ngIf="isVdi"
          >All User Sessions</ng-option
        >
        <ng-option value="PrimeNonPrimeCoreUsage" *ngIf="!isVdi">
          Prime-NonPrime Core Usage
        </ng-option>
        <ng-option value="NodeStartStopStatus" *ngIf="isVdi"
          >Node Start/Stop Status</ng-option
        >
        <ng-option value="NodeUtilizationByNodeGroup" *ngIf="!isVdi"
          >Utilization By Node Group</ng-option
        >
        <ng-option value="HpcUnitsConsumed" *ngIf="!isVdi"
          >HPC Units Consumed</ng-option
        >
        <ng-option value="CpuUsageByNodes" *ngIf="!isVdi"
          >CPU Usage By Nodes</ng-option
        >
        <ng-option value="CpuUsageByNodeGroups" *ngIf="!isVdi"
          >CPU Usage By Node Groups</ng-option
        >
        <ng-option value="CoreUsageByNodes" *ngIf="!isVdi"
          >Core Usage By Nodes</ng-option
        >
        <ng-option value="CoreUsageByNodeGroups" *ngIf="!isVdi"
          >Core Usage By Node Groups</ng-option
        >
        <ng-option value="JobDurationsByDay" *ngIf="!isVdi"
          >Job Duration By Day</ng-option
        >
        <ng-option value="JobsByUserByDay" *ngIf="!isVdi"
          >Jobs By User By Day</ng-option
        >
      </ng-select>
      <form [formGroup]="graphFilterForm">
        <ng-template [ngIf]="selectedMetric == 'JobByUser'">
          <ng-multiselect-dropdown
            name="userNames"
            [placeholder]="'Choose Users'"
            [settings]="dropdownSettings"
            [data]="userNames"
            formControlName="userNames"
            [disabled]="false"
          >
          </ng-multiselect-dropdown>
        </ng-template>
        <ng-template [ngIf]="selectedMetric == 'CoreHoursByUsers'">
          <ng-multiselect-dropdown
            name="coreHourUserNames"
            [placeholder]="'Choose Users'"
            [settings]="coreHoursDropdownSettings"
            [data]="coreHourUserNames"
            formControlName="coreHourUserNames"
            [disabled]="false"
          >
          </ng-multiselect-dropdown>
        </ng-template>
        <ng-template
          [ngIf]="
            selectedMetric == 'JobByGroup' ||
            selectedMetric == 'CoreHoursByGroups'
          "
        >
          <ng-multiselect-dropdown
            name="userGroupNames"
            [placeholder]="'Choose Groups'"
            [settings]="dropdownSettings"
            [data]="userGroupNames"
            formControlName="userGroupNames"
            [disabled]="false"
          >
          </ng-multiselect-dropdown>
        </ng-template>
        <ng-template
          [ngIf]="
            selectedMetric == 'JobByTags' || selectedMetric == 'JobByTagsPerDay'
          "
        >
          <ng-multiselect-dropdown
            name="jobTags"
            [placeholder]="'Choose Tags'"
            [settings]="dropdownSettings"
            [data]="jobTags"
            formControlName="jobTags"
            [disabled]="false"
          >
          </ng-multiselect-dropdown>
        </ng-template>
      </form>
      <ng-select
        #userFilter
        id="userFilter"
        title="Choose Only Single User"
        name="UserFilter"
        *ngIf="
          selectedMetric == 'SessionGraph' ||
          selectedMetric == 'JobsByUserByDay'
        "
        [disabled]="false"
        [(ngModel)]="userFilterValue"
        [clearable]="false"
        class="ngselect me-2"
      >
        <ng-option selected value="none">Select User</ng-option>
        <ng-option *ngFor="let user of userNamesForSessionGraph" [value]="user">
          {{ user }}
        </ng-option>
      </ng-select>
      <ng-select
        #workstationFilter
        title="Choose Only Single Node"
        name="workstationFilter"
        id="workstationFilter"
        [(ngModel)]="wsValue"
        *ngIf="selectedMetric == 'SingleNodeUtilization'"
        [clearable]="false"
        class="ngselect me-2"
      >
        <ng-option selected value="none">Select Workstation</ng-option>
        <ng-option *ngFor="let ws of wsNames" [value]="ws">{{ ws }}</ng-option>
      </ng-select>

      <ng-select
        #nodeGroupFilter
        title="Choose any one Node Group"
        name="nodeGroupFilter"
        id="nodeGroupFilter"
        [clearable]="false"
        class="ngselect me-2"
        [(ngModel)]="nodeGroupValue"
        *ngIf="selectedMetric == 'NodeUtilizationByNodeGroup'"
      >
        <ng-option selected value="none">Select Node Group</ng-option>
        <ng-option *ngFor="let ws of nodeGroups" [value]="ws">{{
          ws
        }}</ng-option>
      </ng-select>

      <ng-select
        id=""
        name="chartType"
        [(ngModel)]="activeChartType"
        *ngIf="selectedMetric != 'all' && availableChartTypes.length > 1"
        [clearable]="false"
        class="ngselect me-2"
      >
        <ng-option
          *ngFor="let chart of availableChartTypes"
          value="{{ chart?.toLowerCase() }}"
        >
          {{ chart }}
        </ng-option>
      </ng-select>

      <input
        #dateFilter
        name="dateFilter"
        [(ngModel)]="dateFilterValue"
        container="body"
        placement="right auto"
        triggers="hover"
        ngbTooltip="Strictly add 'hr' with value if value is in hours or add 'days' with value if value is in days"
        [matAutocomplete]="queue"
        class="me-2 inputbar"
      />

      <mat-autocomplete
        #queue="matAutocomplete"
        (optionSelected)="onOptionClick(dateFilterValue)"
      >
        <mat-option value="1 days" *ngIf="selectedMetric != 'JobsByUserByDay'"
          >Last 24hrs</mat-option
        >
        <mat-option value="7 days" selected>7 Days</mat-option>
        <mat-option value="30 days">30 Days</mat-option>
        <mat-option value="90 days">90 Days</mat-option>
        <mat-option value="180 days">180 Days</mat-option>
        <mat-option value="365 days">1 Year</mat-option>
        <mat-option value="custom">Custom</mat-option>
      </mat-autocomplete>

      @if(dateFilter.value == 'custom'){
      <input
        [min]="prevDate"
        [max]="todayDate"
        [owlDateTimeTrigger]="dt8"
        [owlDateTime]="dt8"
        [selectMode]="'range'"
        [formControl]="dateTimePeriod"
        class="me-2 inputbar"
        placeholder="Choose period"
      />
      <owl-date-time [pickerType]="'calendar'" #dt8></owl-date-time>
      }

      <ng-select
        *ngIf="
          ![
            'JobSummary',
            'JobCompleted',
            'JobWaitTime',
            'JobByUser',
            'JobByGroup',
            'JobByApplication',
            'JobByNodes',
            'CoresByApplication',
            'CoreHoursByUsers',
            'JobByTags',
            'CoreUsageByNodes',
            'CoreUsageByNodeGroups',
            'CpuUsageByNodes',
            'CpuUsageByNodeGroups',
            'JobByNodeGroup',
            'JobDurationsByDay',
            'JobByTagsPerDay',
            'RunningQueuedJobsPerNodeGroup',
            'AllUserSessions',
            'NodeStartStopStatus'
          ].includes(selectedMetric) || dateFilter.value.includes('hr')
        "
        [(ngModel)]="granularityValue"
        title="Choose Granularity"
        name="granularity"
        #granularity
        [clearable]="false"
        [searchable]="false"
        class="ngselect me-2"
        (ngModelChange)="granularityChanged()"
      >
        <ng-option
          *ngFor="
            let gran of getGranularityForMetric(
              selectedMetric,
              dateFilter.value
            )
          "
          [value]="gran"
        >
          {{ gran }}
        </ng-option>
      </ng-select>
      <button
        class="actionBtn"
        (click)="
          applyFilters(
            metricFilter?.value,
            userFilterValue,
            dateFilter?.value,
            granularity?.value,
            wsValue,
            'all',
            'all'
          )
        "
        triggers="hover"
        ngbTooltip="Apply  Filters"
      >
        <span class="bi bi-check-circle"></span>
      </button>
      <button
        type="button"
        class="actionBtn"
        [class.gray]="disableApplyFilter"
        [disabled]="disableApplyFilter"
        (click)="resetFilter()"
        #btnResetFilter
        triggers="hover"
        ngbTooltip="Reset applied Filters"
      >
        <span class="bi bi-x-lg text-danger"></span>
      </button>

      <div class="" ngbDropdown container="body">
        <button
          type="button"
          title="Download all jobs details"
          class="actionBtn"
          ngbDropdownToggle
        >
          <span class="bi bi-download"></span>
        </button>
        <div ngbDropdownMenu>
          <button
            ngbDropdownItem
            *ngIf="isVdi == false"
            title="Download Job Info"
            (click)="downloadJobData()"
          >
            Job Info
          </button>

          <button
            *ngFor="let control of dynamicControls"
            ngbDropdownItem
            [title]="control.tooltip"
            (click)="handleControlClick(control)"
          >
            {{ control.text }}
          </button>
          <!-- <button ngbDropdownItem
          title="Download Current Chart Data"
          (click)="downloadAllCanvas()">
    {{ selectedMetric == 'all' ? "All Charts" : "Chart" }}
  </button> -->
          <button
            ngbDropdownItem
            *ngIf="selectedMetric != 'all'"
            title="Download Current Chart Data"
            (click)="
              applyFilters(
                metricFilter?.value,
                !userFilter?.value,
                dateFilter?.value,
                granularity?.value,
                workstationFilter?.value,
                'all',
                'all',
                true
              )
            "
          >
            Chart Data
          </button>
          <button
            ngbDropdownItem
            title="Export shown charts as PDF"
            (click)="isVdi ? generatePdfVDI(false) : generatePdfHPC(false)"
          >
            Export to PDF
          </button>
          <button
            ngbDropdownItem
            title="Share shown charts as PDF by email"
            *ngIf="
              selectedMetric != 'SessionGraph' &&
              selectedMetric != 'NodeStartStopStatus' &&
              selectedMetric != 'AllUserSessions'
            "
            (click)="isVdi ? generatePdfVDI(true) : generatePdfHPC(true)"
          >
            Send Report
          </button>
          <button
            type="button"
            ngbDropdownItem
            title="Download session details in csv file"
            style="margin-left: 0"
            (click)="downloadSessionInfo()"
            #btnDownloadJob
          >
            Session Info
          </button>
          <button
            ngbDropdownItem
            title="Download node utilization data points in csv file"
            (click)="downloadNodeUtilization()"
          >
            Node Utilization
          </button>
        </div>
        <button
          type="button"
          class="actionBtn"
          (click)="requestRefresh()"
          triggers="hover"
          ngbTooltip="Refresh Details"
        >
          <span class="bi bi-arrow-clockwise"></span>
        </button>
      </div>
    </div>
    <div *ngIf="showFilters">
      <div class="container">
        <div class="row">
          <div class="col">
            <p class="propertyTitle" style="font-size: 12px">
              Report Taken On : {{ currentDate }}
            </p>
          </div>
          <div class="w-100"></div>
          <div class="col">
            <p class="propertyTitle" style="font-size: 12px">
              Deployment : {{ depName }}
            </p>
          </div>
          <div class="w-100"></div>
          <div class="col">
            <p class="propertyTitle" style="font-size: 12px">
              Category : {{ metricValue }}
            </p>
          </div>
          <div class="w-100"></div>
          <div class="col" *ngIf="selectedMetric == 'SessionGraph'">
            <p class="propertyTitle" style="font-size: 12px">
              User : {{ userValue }}
            </p>
          </div>
          <div class="w-100"></div>
          <div class="col" *ngIf="selectedMetric == 'SingleNodeUtilization'">
            <p class="propertyTitle" style="font-size: 12px">
              Workstation : {{ wsNameValue }}
            </p>
          </div>
          <div class="w-100"></div>
          <div class="col">
            <p class="propertyTitle" style="font-size: 12px">
              Duration : {{ daysValue }}
            </p>
          </div>
          <div class="w-100"></div>
          <div class="col">
            <p class="propertyTitle" style="font-size: 12px">
              Granularity : {{ granularityValue }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <br />
  </div>
  <div *ngIf="selectedMetric == 'all'">
    <div *ngIf="isVdi">
      <div class="charts centerCharts">
        <div style="height: 35vh; width: 30vw">
          <canvas
            baseChart
            [data]="nodeUtilizationDataTotal"
            [options]="nodeUtilizationOptionsTotal"
            [type]="nodeUtilizationType"
          ></canvas>
        </div>
        <div style="height: 35vh; width: 30vw">
          <canvas
            baseChart
            [data]="nodeUtilizationDataOffice"
            [options]="nodeUtilizationOptionsTotalOffice"
            [type]="nodeUtilizationType"
          ></canvas>
        </div>
        <div style="height: 35vh; width: 30vw">
          <canvas
            baseChart
            [data]="nodeUtilizationDataNonOffice"
            [options]="nodeUtilizationOptionsNonOffice"
            [type]="nodeUtilizationType"
          ></canvas>
        </div>
      </div>
      <!--<p>Active Sessions per deployment</p>-->
      <!-- <hr /> -->
      <!--<div class="charts centerCharts">
          <div style="height: 35vh; width: 30vw">
            <canvas baseChart
                    [data]="activeSessionsByProfileDataTotal"
                    [options]="activeSessionsByProfileOptions"
                    [type]="nodeUtilizationType"></canvas>
          </div>
        <div style="height: 35vh; width: 30vw">

        </div>
        <div style="height: 35vh; width: 30vw">

        </div>
      </div>-->
    </div>
    <div *ngIf="!isVdi">
      <div class="charts" *ngIf="selectedMetric == 'all'">
        <!-- <div class="chart">
          <canvas baseChart
                  id="allJobs"
                  height="220"
                  width="355"
                  [data]="allJobsData"
                  [type]="allJobsType"
                  [options]="allJobsOptions"
                  [plugins]="allJobsPlugins"
                  [colors]="allJobsColors">
          </canvas>
        </div> -->
        <!--<p>Prime - Non-Prime Hours Job Submission</p>-->
        <div class="chart">
          <canvas
            baseChart
            id="completedJobs"
            height="220"
            width="350"
            [data]="jobsSummaryData"
            [type]="jobsSummaryType"
            [options]="jobsSummaryOptions"
            [plugins]="jobsSummaryPlugins"
          >
          </canvas>
        </div>
        <div class="chart">
          <canvas
            baseChart
            id="allJobs"
            height="220"
            width="355"
            [data]="primeNonPrimeHoursJobsSubmissionData"
            [options]="primeNonPrimeHoursJobsSubmissionOptions"
            [type]="primeNonPrimeHoursJobsSubmissionType"
          ></canvas>
        </div>
        <div class="chart">
          <canvas
            baseChart
            id="storageUsage"
            height="220"
            width="350"
            [data]="storageChartData"
            [options]="storageChartOptions"
            [type]="storageChartType"
            [plugins]="storageChartPlugins"
          >
          </canvas>
        </div>
      </div>
      <br />
      <div class="charts mt-5" *ngIf="selectedMetric == 'all'">
        <div class="chart">
          <canvas
            baseChart
            id="avgCoreUsage"
            height="220"
            width="355"
            [data]="coresPerDayData"
            [options]="coresPerDayOptions"
            [type]="coresPerDayType"
            [plugins]="coresPerDayPlugins"
          >
          </canvas>
        </div>
        <div class="chart">
          <canvas
            id="jobDataCount"
            baseChart
            height="220"
            width="350"
            [data]="jobCountChartData"
            [options]="jobCountChartOptions"
            [type]="jobCountChartType"
            [plugins]="jobCountChartPlugins"
          >
          </canvas>
        </div>
        <div class="chart">
          <canvas
            id="jobByApplication"
            baseChart
            height="220"
            width="350"
            [data]="jobByApplicationData"
            [options]="jobByApplicationOptions"
            [type]="jobByApplicationType"
            [plugins]="jobByApplicationPlugins"
          >
          </canvas>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="activeChartType != 'table'; else tabularData"
    class="flex-grow-1 w-100"
  >
    <div class="charts w-100 centerCharts" *ngIf="selectedMetric != 'all'">
      <div
        *ngIf="selectedMetric == 'SessionGraph' && selectedUser != 'none'"
        class="col-md-12 row"
      >
        <div
          class="col-md-6 p-1"
          style="max-height: 70vh; overflow-y: auto"
          #pdfContentSessionEndStart
        >
          <p>{{ selectedUser | titlecase }} Session Start / End Activity :</p>
          <google-chart
            *ngFor="let graph of graphStartEnd"
            #chart
            [type]="type"
            [data]="graph.data"
            [options]="graph.options"
            [columnNames]="colNames"
            [height]="chartHeight"
            [width]="chartWidth"
          >
          </google-chart>
        </div>
        <div
          class="col-md-6 p-1"
          style="max-height: 70vh; overflow-y: auto"
          #pdfContentSessionConDisConnect
        >
          <p>
            {{ selectedUser | titlecase }} Session Connect / Disconnect Activity
            :
          </p>
          <google-chart
            *ngFor="let graph of graphConnDiscon"
            #chart
            [type]="type"
            [data]="graph.data"
            [options]="graph.options"
            [columnNames]="colNames"
            [height]="chartHeight"
            [width]="chartWidth"
          >
          </google-chart>
        </div>
      </div>
      <div class="singleChart" *ngIf="selectedMetric == 'JobSummary'">
        <canvas
          baseChart
          id="allJobs"
          style="width: 70vw; height: 60vh"
          [data]="allJobsData"
          [type]="allJobsType"
          [options]="allJobsOptions"
          [plugins]="allJobsPlugins"
          [colors]="allJobsColors"
        >
        </canvas>
      </div>
      <div *ngIf="selectedMetric == 'JobCompleted'">
        <canvas
          id="completedJobs"
          baseChart
          style="width: 70vw; height: 60vh"
          [data]="jobsSummaryData"
          [type]="jobsSummaryType"
          [options]="jobsSummaryOptions"
          [plugins]="jobsSummaryPlugins"
        >
        </canvas>
      </div>
      <div class="singleChart d-flex" *ngIf="selectedMetric == 'StorageUsage'">
        <canvas
          id="storageUsage"
          baseChart
          style="width: 70vw; height: 60vh"
          [data]="storageChartData"
          [options]="storageChartOptions"
          [type]="storageChartType"
          [plugins]="storageChartPlugins"
        >
        </canvas>
        <div
          *ngIf="!showDataLabelOptions(); else dataLabels"
          class="labelOptions d-flex flex-column justify-content-center"
        ></div>
      </div>
      <!-- <div class="singleChart d-flex" *ngIf="selectedMetric == 'StorageUsage'">
    <canvas
            id="storageUsage"
            baseChart
            height="350"
            width="1000"
            class="chart-canvas"
            [datasets]="storageChartData"
            [labels]="storageChartLabels"
            [options]="storageChartOptions"
            [legend]="storageChartLegend"
            [plugins]="storageChartPlugins"
            [chartType]="storageChartType"
            >
    </canvas>
    <div *ngIf="!showDataLabelOptions(); else dataLabels" class="labelOptions d-flex flex-column justify-content-center">
    </div>
  </div> -->
      <div *ngIf="selectedMetric == 'CoreUsage'">
        <canvas
          id="avgCoreUsage"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="coresPerDayData"
          [options]="coresPerDayOptions"
          [type]="coresPerDayType"
          [plugins]="coresPerDayPlugins"
        >
        </canvas>
      </div>
      <div class="singleChart d-flex" *ngIf="selectedMetric == 'JobDataCount'">
        <canvas
          id="jobDataCount"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="jobCountChartData"
          [options]="jobCountChartOptions"
          [type]="jobCountChartType"
          [plugins]="jobCountChartPlugins"
        >
        </canvas>
        <div
          *ngIf="!showDataLabelOptions(); else dataLabels"
          class="labelOptions d-flex flex-column justify-content-center"
        ></div>
      </div>
      <div
        class="singleChart d-flex"
        *ngIf="selectedMetric == 'JobByApplication'"
      >
        <canvas
          id="jobByApplication"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="jobByApplicationData"
          [options]="jobByApplicationOptions"
          [type]="jobByApplicationType"
          [plugins]="jobByApplicationPlugins"
        >
        </canvas>
        <div
          *ngIf="!showDataLabelOptions(); else dataLabels"
          class="labelOptions d-flex flex-column justify-content-center"
        ></div>
      </div>
      <div class="singleChart" *ngIf="selectedMetric == 'JobWaitTime'">
        <canvas
          id="jobWaitTime"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="jobWaitTimeChartData"
          [options]="jobWaitTimeChartOptions"
          [type]="jobWaitTimeChartType"
          [plugins]="jobWaitTimeChartPlugins"
        >
        </canvas>
      </div>
      <div *ngIf="selectedMetric == 'NodeAvailability'">
        <canvas
          id="nodeAvailability"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="nodeAvailabilityData"
          [options]="nodeAvailabilityChartOptions"
          [type]="nodeAvailabilityType"
          [plugins]="nodeAvailabilityPlugins"
        >
        </canvas>
      </div>
      <div class="singleChart" *ngIf="selectedMetric == 'JobByUser'">
        <canvas
          id="jobByUser"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="jobByUserChartData"
          [options]="jobByUserChartOptions"
          [type]="jobByUserChartType"
          [plugins]="jobByUserChartPlugins"
        >
        </canvas>
      </div>
      <div class="singleChart" *ngIf="selectedMetric == 'JobByGroup'">
        <canvas
          id="jobByGroup"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="jobByGroupChartData"
          [options]="jobByGroupChartOptions"
          [type]="jobByGroupChartType"
          [plugins]="jobByGroupChartPlugins"
        >
        </canvas>
      </div>
      <div class="chart" *ngIf="selectedMetric == 'JobByNodes'">
        <canvas
          id="jobByNodes"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="jobByNodesData"
          [options]="jobByNodesOptions"
          [type]="jobByNodesType"
          [plugins]="jobByNodesPlugins"
        >
        </canvas>
      </div>

      <div class="chart" *ngIf="selectedMetric == 'JobByNodeGroup'">
        <canvas
          id="jobByNodeGroup"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="jobByNodesData"
          [options]="jobByNodesOptions"
          [type]="jobByNodesType"
          [plugins]="jobByNodesPlugins"
        >
        </canvas>
      </div>

      <!--<div>CPU Usage By Nodes in Bar Graph</div>-->
      <div class="chart" *ngIf="selectedMetric == 'CpuUsageByNodes'">
        <canvas
          id="cpuByNodes"
          baseChart
          class="chart-canvas"
          style="width: 69vw; height: 60vh"
          [data]="cpuUsageByNodesChartData"
          [options]="cpuUsageByNodesChartOptions"
          [type]="cpuUsageByNodesChartType"
          [plugins]="cpuUsageByNodesChartPlugins"
        >
        </canvas>
      </div>

      <!--<div>CPU Usage By Node Groups in Bar Graph</div>-->
      <div class="chart" *ngIf="selectedMetric == 'CpuUsageByNodeGroups'">
        <canvas
          id="cpuByNodeGroups"
          baseChart
          style="width: 69vw; height: 60vh"
          class="chart-canvas"
          [data]="cpuUsageByNodeGroupsChartData"
          [options]="cpuUsageByNodeGroupsChartOptions"
          [type]="cpuUsageByNodeGroupsChartType"
          [plugins]="cpuUsageByNodeGroupsChartPlugins"
        >
        </canvas>
      </div>

      <!--<div>Core Usage By Nodes in Bar Graph</div>-->
      <div class="chart" *ngIf="selectedMetric == 'CoreUsageByNodes'">
        <canvas
          id="cpuByNodes"
          baseChart
          class="chart-canvas"
          style="width: 69vw; height: 60vh"
          [data]="coreUsageByNodesChartData"
          [options]="coreUsageByNodesChartOptions"
          [type]="coreUsageByNodesChartType"
          [plugins]="coreUsageByNodesChartPlugins"
        >
        </canvas>
      </div>

      <!--<div>Core Usage By Node Groups in Bar Graph</div>-->
      <div class="chart" *ngIf="selectedMetric == 'CoreUsageByNodeGroups'">
        <canvas
          id="cpuByNodeGroups"
          baseChart
          style="width: 69vw; height: 60vh"
          class="chart-canvas"
          [data]="coreUsageByNodeGroupsChartData"
          [options]="coreUsageByNodeGroupsChartOptions"
          [type]="coreUsageByNodeGroupsChartType"
          [plugins]="coreUsageByNodeGroupsChartPlugins"
        >
        </canvas>
      </div>

      <div class="chart" *ngIf="selectedMetric == 'JobByTags'">
        <canvas
          id="jobByTags"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="jobByTagsData"
          [options]="jobByTagsOptions"
          [type]="jobByTagsType"
          [plugins]="jobByTagsPlugins"
        >
        </canvas>
      </div>
      <div
        class="singleChart d-flex"
        *ngIf="selectedMetric == 'CoresByApplication'"
      >
        <canvas
          id="coresByApplication"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="coresByApplicationChartData"
          [options]="coresByApplicationChartOptions"
          [type]="coresByApplicationChartType"
          [plugins]="coresByApplicationChartPlugins"
        >
        </canvas>
        <div
          *ngIf="!showDataLabelOptions(); else dataLabels"
          class="labelOptions d-flex flex-column justify-content-center"
        ></div>
      </div>
      <div
        class="singleChart"
        *ngIf="selectedMetric == 'CoreHoursByUsers' && activeChartType == 'bar'"
      >
        <canvas
          id="coreHoursByUsersBar"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="coreHoursByUsersChartData"
          [options]="coreHoursByUsersChartOptions"
          [type]="coreHoursByUsersChartType"
          [plugins]="coreHoursByUsersChartPlugins"
        >
        </canvas>
      </div>
      <div
        class="singleChart"
        *ngIf="selectedMetric == 'CoreHoursByUsers' && activeChartType == 'pie'"
      >
        <canvas
          baseChart
          id="coreHoursByUsersPie"
          style="width: 70vw; height: 60vh"
          [data]="coreHoursByUsersPieData"
          [type]="coreHoursByUsersPieType"
          [options]="coreHoursByUsersPieOptions"
          [plugins]="coreHoursByUsersPiePlugins"
          [colors]="coreHoursByUsersPieColors"
        >
        </canvas>
      </div>
      <div
        class="singleChart"
        *ngIf="
          selectedMetric == 'CoreHoursByGroups' && activeChartType == 'bar'
        "
      >
        <canvas
          id="coreHoursByGroupsBar"
          baseChart
          style="width: 70vw; height: 60vh"
          [data]="coreHoursByGroupsChartData"
          [options]="coreHoursByGroupsChartOptions"
          [plugins]="coreHoursByGroupsChartPlugins"
          [type]="coreHoursByGroupsChartType"
        ></canvas>
      </div>
      <div
        class="singleChart"
        *ngIf="
          selectedMetric == 'CoreHoursByGroups' && activeChartType == 'pie'
        "
      >
        <canvas
          id="coreHoursByGroupsPie"
          baseChart
          style="width: 70vw; height: 60vh"
          [data]="coreHoursByGroupsPieData"
          [type]="coreHoursByGroupsPieType"
          [options]="coreHoursByGroupsPieOptions"
          [plugins]="coreHoursByGroupsPiePlugins"
          [colors]="coreHoursByGroupsPieColors"
        >
        </canvas>
      </div>
      <div
        class="singleChart d-flex primeNonPrime"
        *ngIf="selectedMetric == 'PrimeNonPrimeCoreUsage'"
        style="overflow: auto"
      >
        <canvas
          id="primeCoreUsage"
          baseChart
          style="width: 1100px; height: 500px"
          [data]="primeCoreUsageChartData"
          [options]="primeCoreUsageChartOptions"
          [type]="primeCoreUsageChartType"
          [plugins]="primeCoreUsageChartPlugins"
        >
        </canvas>
        <canvas
          id="nonPrimeCoreUsage"
          class="ms-4"
          baseChart
          style="width: 1100px; height: 500px"
          [data]="nonPrimeCoreUsageChartData"
          [options]="nonPrimeCoreUsageChartOptions"
          [type]="nonPrimeCoreUsageChartType"
          [plugins]="nonPrimeCoreUsageChartPlugins"
        >
        </canvas>
      </div>
      <!--<p>Active Sessions per deployment</p>-->
      <div class="singleChart" *ngIf="selectedMetric == 'ActiveSessions'">
        <div>
          <div style="height: 60vh; width: 69vw">
            <canvas
              baseChart
              [data]="activeSessionsByProfileDataTotal"
              [options]="activeSessionsByProfileOptions"
              [type]="nodeUtilizationType"
            ></canvas>
          </div>
        </div>
      </div>

      <!--<p>HPC Units Consumed</p>-->
      <div class="singleChart" *ngIf="selectedMetric == 'HpcUnitsConsumed'">
        <div>
          <div style="height: 60vh; width: 69vw">
            <canvas
              baseChart
              [data]="hpcUnitsConsumedDataTotal"
              [options]="hpcUnitsConsumedOptions"
              [type]="nodeUtilizationType"
            ></canvas>
          </div>
        </div>
      </div>

      <!--<p>JobDurationsByDay</p>-->
      <div class="chart" *ngIf="selectedMetric == 'JobDurationsByDay'">
        <canvas
          id="jobDurationsByDay"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="jobDurationsByDayData"
          [options]="jobDurationsByDayOptions"
          [type]="jobDurationsByDayType"
          [plugins]="jobDurationsByDayPlugins"
        >
        </canvas>
      </div>

      <!--<p>Jobs by tags per day</p>-->
      <div
        class="singleChart d-flex"
        *ngIf="selectedMetric == 'JobByTagsPerDay'"
      >
        <canvas
          id="jobByTagsPerDay"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="jobByTagsPerDayChartData"
          [options]="jobByTagsPerDayChartOptions"
          [type]="jobByTagsPerDayChartType"
          [plugins]="jobByTagsPerDayChartPlugins"
        >
        </canvas>
        <div
          *ngIf="!showDataLabelOptions(); else dataLabels"
          class="labelOptions d-flex flex-column justify-content-center"
        ></div>
      </div>

      <!--<p>Running and Queued Jobs by Node Group</p>-->
      <div
        class="singleChart d-flex"
        *ngIf="selectedMetric == 'RunningQueuedJobsPerNodeGroup'"
      >
        <canvas
          id="RunningQueuedJobsPerNodeGroup"
          baseChart
          style="width: 69vw; height: 60vh"
          [data]="runningQueuedJobsPerNodeGroupChartData"
          [options]="runningQueuedJobsPerNodeGroupChartOptions"
          [type]="runningQueuedJobsPerNodeGroupChartType"
          [plugins]="runningQueuedJobsPerNodeGroupChartPlugins"
        >
        </canvas>
        <div
          *ngIf="!showDataLabelOptions(); else dataLabels"
          class="labelOptions d-flex flex-column justify-content-center"
        ></div>
      </div>

      <!--<p>Prime - Non-Prime Hours Job Submission</p>-->
      <div
        class="singleChart"
        *ngIf="selectedMetric == 'PrimeNonPrimeJobSubmission'"
      >
        <div>
          <div style="height: 60vh; width: 69vw">
            <canvas
              baseChart
              [data]="primeNonPrimeHoursJobsSubmissionData"
              [options]="primeNonPrimeHoursJobsSubmissionOptions"
              [type]="primeNonPrimeHoursJobsSubmissionType"
            ></canvas>
          </div>
        </div>
      </div>

      <!-- ! Jobs By User Per Day chart -->
      <div
        class="singleChart d-flex jobsByUserByDay"
        *ngIf="selectedMetric == 'JobsByUserByDay'"
        style="height: 60vh; width: 69vw"
      >
        <canvas
          id="jobsByUserByDay"
          class="ms-4"
          baseChart
          style="width: 1100px; height: 500px"
          [data]="jobsByUserByDayData"
          [options]="jobsByUserByDayOptions"
          [type]="jobsByUserByDayType"
        >
        </canvas>
      </div>
      <!-- ! Jobs By User Per Day chart END -->
    </div>
  </div>

  <div
    *ngIf="
      selectedMetric == 'AllUserSessions' &&
      timelineChartData.dataTable.length > 1
    "
  >
    <div style="height: 60vh">
      <!--<google-chart [data]="timelineChartData"></google-chart>-->
      <google-chart
        #chart
        id="chart_div"
        type="Timeline"
        [data]="timelineChartData.dataTable"
        [height]="chartHeight"
        [width]="chartWidth"
        [options]="timelineChartData.options"
      >
      </google-chart>
    </div>
  </div>

  <div
    *ngIf="
      selectedMetric == 'NodeStartStopStatus' &&
      nodeStatusTimelineChartData.dataTable.length > 1
    "
  >
    <div style="height: 60vh">
      <!--<google-chart [data]="timelineChartData"></google-chart>-->
      <google-chart
        #chart
        id="chart_div"
        type="Timeline"
        [data]="nodeStatusTimelineChartData.dataTable"
        [height]="chartHeight"
        [width]="chartWidth"
        [options]="nodeStatusTimelineChartData.options"
      >
      </google-chart>
    </div>
  </div>

  <div
    class="charts centerCharts"
    *ngIf="
      selectedMetric == 'NodeUtilization' ||
      selectedMetric == 'SingleNodeUtilization' ||
      selectedMetric == 'NodeUtilizationByNodeGroup'
    "
  >
    <div style="height: 35vh; width: 30vw">
      <canvas
        baseChart
        [data]="nodeUtilizationDataTotal"
        [options]="nodeUtilizationOptionsTotal"
        [type]="nodeUtilizationType"
      ></canvas>
    </div>
    <div style="height: 35vh; width: 30vw">
      <canvas
        baseChart
        [data]="nodeUtilizationDataOffice"
        [options]="nodeUtilizationOptionsTotalOffice"
        [type]="nodeUtilizationType"
      ></canvas>
    </div>
    <div style="height: 35vh; width: 30vw">
      <canvas
        baseChart
        [data]="nodeUtilizationDataNonOffice"
        [options]="nodeUtilizationOptionsNonOffice"
        [type]="nodeUtilizationType"
      ></canvas>
    </div>
  </div>
  <ngx-spinner
    bdColor="rgba(0,0,0,0.5)"
    size="medium"
    zIndex="1"
    color="#fffff"
    type="ball-spin"
    [fullScreen]="false"
    name="downloadingFile"
  >
    <p style="color: white; font-size: 16px">
      Downloading file, please wait...
    </p>
  </ngx-spinner>
</div>

<ng-template #dataLabels>
  <form action="" [formGroup]="graphDataLabelsForm" class="ms-4">
    <fieldset>
      <legend
        *ngIf="
          selectedMetric != 'JobByTagsPerDay' &&
          selectedMetric != 'JobByApplication' &&
          selectedMetric != 'RunningQueuedJobsPerNodeGroup'
        "
      >
        Show Data labels
      </legend>
      <legend *ngIf="selectedMetric == 'JobByTagsPerDay'">
        Select Job Tag
      </legend>
      <legend *ngIf="selectedMetric == 'RunningQueuedJobsPerNodeGroup'">
        Select Node Group
      </legend>
      <legend *ngIf="selectedMetric == 'JobByApplication'">
        Select Application
      </legend>
      <div *ngIf="selectedMetric == 'JobDataCount'">
        <div>
          <input
            formControlName="jobCountSubmitted"
            (click)="updateChartDataLabel()"
            type="checkbox"
            name="submitted"
          />
          <label for="submitted"> Submitted</label>
        </div>
        <div>
          <input
            formControlName="jobCountSucceeded"
            (click)="updateChartDataLabel()"
            type="checkbox"
            name="succeeded"
          />
          <label for="succeeded"> Succeeded</label>
        </div>
        <div>
          <input
            formControlName="jobCountFailed"
            (click)="updateChartDataLabel()"
            type="checkbox"
            name="failed"
          />
          <label for="failed"> Failed</label>
        </div>
        <div>
          <input
            formControlName="jobCountCancelled"
            (click)="updateChartDataLabel()"
            type="checkbox"
            name="cancelled"
          />
          <label for="cancelled"> Cancelled</label>
        </div>
      </div>

      <div
        *ngIf="selectedMetric == 'JobByTagsPerDay'"
        class="heightOverflowClass"
      >
        <div formArrayName="jobByTagsPerDayForm">
          <div *ngFor="let tag of selectedJobTags; let i = index">
            <input
              type="checkbox"
              [formControlName]="i"
              (click)="tagChanged($event.target.checked, i)"
              [value]="tag.item_text"
              [name]="tag.item_text"
            />
            <label>{{ tag.item_text }}</label>
          </div>
        </div>
      </div>

      <div
        *ngIf="selectedMetric == 'RunningQueuedJobsPerNodeGroup'"
        class="heightOverflowClass"
      >
        <div formArrayName="allNodeGroupsForm">
          <div *ngFor="let nodeGroup of selectedNodeGroups; let i = index">
            <label>
              <input
                type="checkbox"
                [formControlName]="i"
                (click)="nodeGroupChanged($event.target.checked, i, nodeGroup)"
              />
              {{ nodeGroup }}
            </label>
            <!-- <input
              type="checkbox"
              [formControlName]="nodeGroup"
              (click)="nodeGroupChanged($event.target.checked, i, nodeGroup)"
              [value]="nodeGroup" />
            <label>{{ nodeGroup }}</label> -->
          </div>
        </div>
      </div>

      <div *ngIf="selectedMetric == 'JobByApplication'">
        <div formArrayName="jobByApplicationPerDayForm">
          <div *ngFor="let app of applicationNames; let i = index">
            <input
              type="checkbox"
              [formControlName]="i"
              (click)="appsChanged($event.target.checked, i)"
              [value]="app"
              [name]="app"
            />
            <label>{{ app }}</label>
          </div>
        </div>
      </div>

      <div *ngIf="selectedMetric == 'StorageUsage'">
        <div>
          <input
            formControlName="storageUsage"
            (click)="updateChartDataLabel()"
            type="checkbox"
            name="usage"
          />
          <label for="cancelled"> Usage</label>
        </div>
      </div>
      <div *ngIf="selectedMetric == 'CoresByApplication'">
        <div>
          <input
            formControlName="coresByApplication"
            (click)="updateChartDataLabel()"
            type="checkbox"
            name="cores"
          />
          <label for="cancelled"> Cores</label>
        </div>
      </div>
    </fieldset>
  </form>
</ng-template>
<ng-template #tabularData>
  <div class="overflow-auto flex-grow-1 d-flex flex-column align-items-center">
    <mat-form-field class="table-filter">
      <mat-label>Filter</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="Search for any keyword."
        #input
      />
    </mat-form-field>
    <section class="tableContainer">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        (matSortChange)="announceSortChange($event)"
        class="mat-elevation-z8"
      >
        <!-- Dynamic Columns -->
        <ng-container
          *ngFor="let column of displayedColumns"
          [matColumnDef]="column"
        >
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [mat-sort-header]="column"
          >
            {{ getColumnHeader(column) }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </section>
  </div>
</ng-template>
